import styled from 'styled-components';
import color from '../../../config/colors.json';

export const Title = styled.h2`
    color: ${color.darkGrey};
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    line-height: 25px;
    margin-bottom: 32px;
    font-weight: 500;
`;

export const TableBox = styled.div`
    background-color: #fff;
    width: 100%;
    margin-bottom: 32px;
    box-shadow: 0 2px 2px #9C9C9C24;
    border-radius: 8px;
    padding: 32px;
`;


export const Table = styled.table`
    width: 100%;
    margin-bottom: 0;

    > thead {
        border-bottom: 1px solid ${color.lightGrey9};
        > tr {
            > th {
                padding: 0 32px 8px 0;
                width: calc(calc(100% / 5) - 101px);
                > em {
                    color: ${color.lightGrey10a};
                    font-family: 'Poppins', sans-serif;
                    font-size: 8px;
                    line-height: 12px;
                    text-transform: capitalize;
                    font-weight: normal;
                    font-style: normal;
                }
				&:nth-last-of-type(1) {
					width: 101px;
				}
            }
        }
    }
    > tbody {
        border-radius: 5px;
        overflow: hidden;
        > tr {
                border-bottom: 1px solid ${color.lightGrey9};
            > td {
                padding: 16px 0 16px 0;
                > em {
                    color: ${color.darkGrey};
                    font-family: 'Poppins', sans-serif;
                    font-size: 12px;
                    line-height: 12px;
                    font-style: normal;
                    font-weight: 300;
                }
                width: calc(calc(100% / 5) - 101px);
                & .empty-data {
                    display: block;
                }
				&:nth-last-of-type(1) {
					width: 101px;
				}
            }
            &:first-child {
                border-radius: 3px;
                > td:first-child {
                    border-top-left-radius: 5px;
                }
                > td:last-child {
                    border-top-right-radius: 5px;
                }
            }
            &:last-child {
                border-radius: 3px;
                > td:first-child {
                    border-bottom-left-radius: 5px;
                }
                > td:last-child {
                    border-bottom-right-radius: 5px;
                }
            }
        }
    }
`;
